import { render, staticRenderFns } from "./enterNewClientData.vue?vue&type=template&id=bcd5cb52&scoped=true&"
import script from "./enterNewClientData.vue?vue&type=script&lang=js&"
export * from "./enterNewClientData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd5cb52",
  null
  
)

export default component.exports